import React, { useState, useEffect } from 'react';
import { Collapse } from 'tea-component';
import arrowRight from '@/pages/strategic/assests/svg/arrow-fill-black.svg';
import { sessionStorageUtils } from '../../utils/sessionStorage';
import './index.scss';

interface CollapseProps {
  // Storage configuration
  storageKey: string;

  // Collapse configuration
  defaultActiveIds?: string[];
  destroyInactivePanel?: boolean;

  // Panel configuration
  title?: string | React.ReactNode;
  panelId?: string;

  // Content
  children: React.ReactNode;

  // Callback for external state management
  onStateChange?: (activeIds: string[]) => void;

  // Additional props to pass to tea-component Collapse
  className?: string;
  activeIds: string[];
  setActiveIds: (activeIds: string[]) => void;
  [key: string]: any;
}

const CustomCollapse: React.FC<CollapseProps> = ({
  storageKey,
  activeIds,
  setActiveIds,
  defaultActiveIds = [],
  destroyInactivePanel = false,
  title,
  panelId = '1',
  children,
  onStateChange,
  className = '',
  isOpacity,
  ...restProps
}) => {
  // Load collapse state from sessionStorage on component mount
  useEffect(() => {
    const savedCollapseState = sessionStorageUtils.get(storageKey, defaultActiveIds);
    console.log(`savedCollapseState for ${storageKey}:`, savedCollapseState);
    setActiveIds(savedCollapseState);
  }, [storageKey]); // Remove defaultActiveIds from dependency array

  // Handle collapse toggle and save state
  const handleCollapseToggle = (newActiveIds: string[]) => {
    if(isOpacity) return;
    setActiveIds(newActiveIds);
    console.log(`${storageKey} ActiveIds:`, newActiveIds);
    sessionStorageUtils.set(storageKey, newActiveIds);

    // Call external callback if provided
    if (onStateChange) {
      onStateChange(newActiveIds);
    }
  };

  return (
    <Collapse
      activeIds={activeIds}
      onActive={handleCollapseToggle}
      destroyInactivePanel={destroyInactivePanel}
      className={`dbs-collapse-component ${className}`}
      // icon active, rotate 90deg to become arrow down (default is arrow right)
      icon={active => (
        <img
          src={arrowRight}
          alt={active ? 'Arrow Down' : 'Arrow Right'}
          className={`dbs-collapse-arrow${active ? ' active' : ''}`}
        />
      )}
      {...restProps}
    >
      {title ? (
        <Collapse.Panel id={panelId} title={title}>
          {children}
        </Collapse.Panel>
      ) : (
        children
      )}
    </Collapse>
  );
};

export default CustomCollapse;
